module["exports"] = [
  "Libros",
  "Películas",
  "Música",
  "Juegos",
  "Electrónica",
  "Ordenadores",
  "Hogar",
  "Jardín",
  "Herramientas",
  "Ultramarinos",
  "Salud",
  "Belleza",
  "Juguetes",
  "Kids",
  "Baby",
  "Ropa",
  "Zapatos",
  "Joyería",
  "Deportes",
  "Aire libre",
  "Automoción",
  "Industrial"
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/faker/lib/locales/es_MX/commerce/department.js
// module id = 2880
// module chunks = 1610